import React, { useEffect, useState } from "react";
import styles from "./valueStrategy.module.css";
import { getLearnMoreValue } from "../../services/request/learnMore";
import Mail from "../../commomComponents/mail";
import LearnMoreBanner from "./commonComponents/LearnMoreBanner";
import LearnMoreMainText from "./commonComponents/LearnMoreMainText";
import LearnMoreSectionOne from "./commonComponents/LearnMoreSectionOne";
import LearnMoreSectionTwo from "./commonComponents/LearnMoreSectionTwo";
import LearnMoreSectionThree from "./commonComponents/LearnMoreSectionThree";
import DisclaimerText from "./commonComponents/DisclaimerText";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";
let footerTextsProcessInvestment =
  "Please note that BMV framework mentioned above is developed in house and only indicative in nature. The strategies offered by the Portfolio Manager may or may not follow the above framework at all times. The framework is developed in order to select the right companies through a filtration process and endeavor the strategy to attain their investment objective. These models are based on various broad market parameters prevalent in the market and are dynamic in nature.";
export default function ValueStrategy(props) {
  const [res, setRes] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    document.title = "Value PMS: Invest in Top Mutual Funds for Long-Term Growth | ICICI Pru Alternates";
    setLoader(true);
    let response = getLearnMoreValue();
    response.then((resData) => {
      setRes(resData.data.res[0]);
      setLoader(false);
    });
  }, []);

  return (
    <>
      <SeoHelmet
        title="Value PMS: Invest in Top Mutual Funds for Long-Term Growth | ICICI Pru Alternates"
        description="The Value Strategy is one of the PMS strategies that focus on investing in funds and stocks with high potential but are undervalued. Visit ICICI Pru Alternates to learn more."
        url="https://www.iciciprualternates.com/portfolio-management-service/value-strategy"
      />
      <div className={styles.valueStrategy}>
        {loader ? (
          <Loader />
        ) : res ? (
          <>
            <Mail />
            <LearnMoreBanner
              image={res.bannerImage}
              title={res.bannerTitle}
              subTitle={res.bannerSubTitle}
              presentation={res.presentation}
              factSheet={res.factsheet}
            />
            <LearnMoreMainText text={res.mainText} />
            <LearnMoreSectionOne
              title={res.sectionOneTitle}
              data={res.sectionOneContent}
            />
            <LearnMoreSectionTwo
              title={res.sectionTwoTitle}
              data={res.sectionTwoContent}
              disclaimer={footerTextsProcessInvestment}
            />
            <LearnMoreSectionThree
              title={res.sectionThreeTitle}
              data={res.sectionThreeContent}
            />

            <DisclaimerText text={res.disclaimer} />
          </>
        ) : null}
      </div>
    </>
  );
}
